var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebMenubarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 508.31 117.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#003a95}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160.53 34.99h9.46v47.28h-9.46zM234.07 34.99l-23.64 47.28h-9.46l-23.64-47.28h10.4l17.97 35.95 17.97-35.95h10.4zM297.79 44.45h-56.74v-9.46h56.74v9.46Zm0 18.91h-56.74V53.9h56.74v9.46Zm0 18.91h-56.74v-9.46h56.74v9.46ZM314.34 82.27h-9.46V34.99h56.74v9.46h-47.28v37.82zM368.84 82.27V34.99h9.46v37.83h37.82V34.99h9.46v47.28h-56.74zM432.68 82.27v-9.45h47.28v-9.46h-47.28V34.99h56.74v9.46h-47.29v9.46h47.29v28.36h-56.74zM96.76 52.84h56.57v9.43H96.76zM96.76 35.03h56.57v9.43H96.76z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96.76 35.03h9.43V82.2h-9.43zM143.9 35.03h9.43v25.58h-9.43zM140.01 82.51l-26.98-22.48 13.41-1.16 26.89 23.68-13.32-.04z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 39.333 38.538)",
    style: {
      fill: "#ff8b00"
    },
    d: "M24.88 24.09h28.9v28.9h-28.9z"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    transform: "rotate(-45 39.327 79.01)",
    d: "M24.88 64.56h28.9v28.9h-28.9z"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-45 59.563 58.768)",
    style: {
      fill: "#ea0080"
    },
    d: "M45.11 44.32h28.9v28.9h-28.9z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebMenubarLogo);
export default __webpack_public_path__ + "static/media/web-menubar-logo.c68b16e325f0e15a86f2091b6dcb4f13.svg";
export { ForwardRef as ReactComponent };